import React from "react";
import Modal from 'react-modal';
import { Redirect } from 'react-router-dom';
import '../Styles/Sass/LoginModal.scss';
import { firestore, auth } from '../firebase.js';
import firebase from 'firebase';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import '../Styles/Sass/LoginModal.scss';

function LoginModal(props) {
  const [userStatus, setUserStatus] = React.useState(false);

  const uiConfig = {
    signInFlow: 'popup',
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID
    ],
    callbacks: {
      signInSuccess: (res) => {
        firestore.collection('users').doc(`${res.uid}`).get()
          .then(doc => {
            if (doc.exists) {
              console.log('Existing User');
              setUserStatus(true);
            } else {
              firestore.collection("users").doc(res.uid).set({
                name: res.displayName,
                email: res.email,
                verified: false,
                policecheck: false,
                whimis: false,
                job: '',
                jobs: [],
                description: '',
                headline: '',
                rate: '',
                endorsed: [],
                reviews: [],
                uploads: [],
                availability: [],
                areaOfWork: [],
                service: [],
                equipmentNeeded: '',
                suppliesNeeded: '',
                country: '',
                province: '',
                city: '',
                postal: '',
                tos: false,
                endorsements: [
                  {
                    name: 'endorsement1',
                    up: 0,
                    down: 0
                  },
                  {
                    name: 'endorsement2',
                    up: 0,
                    down: 0
                  },
                  {
                    name: 'endorsement3',
                    up: 0,
                    down: 0
                  },
                  {
                    name: 'endorsement4',
                    up: 0,
                    down: 0
                  },
                  {
                    name: 'endorsement5',
                    up: 0,
                    down: 0
                  },
                  {
                    name: 'endorsement6',
                    up: 0,
                    down: 0
                  }
                ]
              })
                .then((docRef) => {
                  console.log("Document written with ID: ", res.uid);
                  setUserStatus(true);
                })
                .catch((error) => {
                  console.error("Error adding document: ", error);
                });
            }
          })
          .then(() => {
            // props.closeModal();
          })
          .catch(err => {
            console.log(err);
          })
      }
    }
  }

  return (
    <Modal
      isOpen={props.modalIsOpen}
      onRequestClose={props.closeModal}
      className='loginmodal'
      overlayClassName='loginmodal__overlay'
    >
      <div className='loginmodal__contentbox'>
        {
          userStatus === true ?
            <Redirect to='/dashboard' /> :
            <></>
        }
        <h3 className='loginmodal__title'>Login Method</h3>
        <StyledFirebaseAuth
          uiConfig={uiConfig}
          firebaseAuth={auth}
        />
        <button className='blueButton loginmodal__button' onClick={props.closeModal}>Close</button>
      </div>
    </Modal>
  );
}

export default LoginModal;